import { render } from "./arrivalCard.vue?vue&type=template&id=0680cede"
import script from "./arrivalCard.vue?vue&type=script&lang=js"
export * from "./arrivalCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__